import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Table,
  Button,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Dialog from 'react-bootstrap-dialog';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';

import { File } from 'components/FileUploadMultiple';
import { ASYNC_COMPROVATION_APPROVAL } from 'store';
import { api } from 'services';
import ActionStatus from 'enums/ActionStatus';

const CreativeApproval = ({ actionId, comprovationApproval, forceUpdate }) => {
  const [arts, setArts] = useState([]);

  const { t } = useTranslation();
  let dialog;

  useEffect(() => {
    api
      .get(`actions/${actionId}/comprovations`)
      .then(({ data }) => {
        setArts(data)
      });
  }, []);

  const getComprovations = () => {
    api.get(`actions/${actionId}/comprovations`).then(({ data }) => {
      setArts(data);
    });
  };

  const statusTask = (statusId) => {
    let icon = '';

    icon =
      statusId === 12 ||  statusId === 18? (
        <OverlayTrigger
          key="top"
          placement="top"
          overlay={<Tooltip id={`tooltip-top`}>{t('label:approved')}</Tooltip>}
        >
          <i style={{ color: 'green' }} className="fas fa-check-circle" />
        </OverlayTrigger>
      ) : statusId === 11 ? (
        <OverlayTrigger
          key="top"
          placement="top"
          overlay={
            <Tooltip id={`tooltip-top`}>{t('label:disapproved')}</Tooltip>
          }
        >
          <i style={{ color: 'red' }} className="fas fa-times-circle" />
        </OverlayTrigger>
      ) : (
        <OverlayTrigger
          key="top"
          placement="top"
          overlay={
            <Tooltip id={`tooltip-top`}>{t('label:awaiting approval')}</Tooltip>
          }
        >
          <i
            style={{ color: 'orange' }}
            className="fas fa-exclamation-circle"
          />
        </OverlayTrigger>
      );
    return icon;
  };

  const approvedArt = (comprovationId, actionId, actionTaskId, actionTaskItemId) => {
    Dialog.setOptions({
      defaultOkLabel: t('label:yes'),
      defaultCancelLabel: t('label:no'),
      primaryClassName: 'btn-success',
      defaultButtonClassName: 'btn-danger',
    });

    dialog.show({
      title: t('title:approval art'),
      body: t('phrase:are you sure?'),
      prompt: Dialog.TextPrompt({ placeholder: t('phrase:add comment') }),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction((comment) => {
          const formData = new FormData();
          formData.append('id', comprovationId);
          
          var status_id = ActionStatus.ApprovedArts;
          if (actionTaskItemId == 53) { // IMPULSIONAMENTO
            status_id = ActionStatus.ApprovedBroadcasting
          }

          formData.append('status_id', status_id);
          formData.append('action_id', actionId);
          formData.append('action_task_item_id', actionTaskId);
          formData.append('comments_approval', comment.value);          
          formData.append('message_alert', t('phrase:approved art'));
          //toast.success(t('phrase:approved art'));
          comprovationApproval(formData);
          forceUpdate();
          getComprovations();
        }),
      ],
      bgSize: 'small',
    });
  };

  const disapprovedArt = (comprovationId, actionId, actionTaskId) => {
    Dialog.setOptions({
      defaultOkLabel: t('label:yes'),
      defaultCancelLabel: t('label:no'),
      primaryClassName: 'btn-success',
      defaultButtonClassName: 'btn-danger',
    });

    dialog.show({
      title: t('title:disapproval art'),
      body: t('phrase:are you sure?'),
      prompt: Dialog.TextPrompt({ placeholder: t('phrase:add comment') }),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction((comment) => {
          const formData = new FormData();
          formData.append('id', comprovationId);
          formData.append('status_id', 11);
          formData.append('action_id', actionId);
          formData.append('action_task_item_id', actionTaskId);
          formData.append('comments_approval', comment.value);
          formData.append('message_alert', t('phrase:disapproved art'));
          //toast.success(t('phrase:disapproved art'));
          comprovationApproval(formData);
          forceUpdate();
          getComprovations();
        }),
      ],
      bgSize: 'small',
    });
  };
  const getLink=(valor)=>{
    let link = valor;
    var link_aux = '';
    if(link.indexOf('http') === -1)
      link_aux += 'http://';
    if(link.indexOf('www') === -1)
      link_aux += 'www.';
    return link_aux+link;
  }
  return (
    <>
      <Dialog
        ref={(component) => {
          dialog = component;
        }}
      />
      <Row className="mt-2">
        <Col>
          <h5>{t('title:creative approval')}</h5>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col>
          <Table bordered>
            <thead>
              <tr>
                <th className="text-center align-middle">
                  {t('label:status')}
                </th>
                <th className="text-center align-middle">
                  {t('label:activity id')}
                </th>
                <th className="text-center align-middle">{t('label:theme')}</th>
                <th className="text-center align-middle w-25">
                  {t('label:additional information')}
                </th>
                <th className="text-center align-middle w-25">
                  {'Link'}
                </th>
                <th className="text-center align-middle w-25">
                  {'Data'}
                </th>
                <th className="text-center align-middle">
                  {t('label:approval art')}
                </th>
                <th className="text-center align-middle">
                  {t('label:actions')}
                </th>
              </tr>
            </thead>
            <tbody>
              {arts.map((art, k) => (
                <tr key={k}>
                  <td className="text-center align-middle">
                    {statusTask(art.status_id)}
                  </td>
                  <td className="text-center align-middle">
                    {art.action_task_item_id}
                  </td>
                  <td className="text-center align-middle">
                    {art.action_task_item.description}
                  </td>
                  <td className="text-center align-middle">
                    {art.observation}
                  </td>
                  <td className="text-center align-middle" style={{wordBreak: 'break-word'}}>
                    {art.link?<a href={getLink(art.link)} target="_blank">{art.link}</a>:'---'}
                  </td>
                  <td className="text-center align-middle">
                    {art.date_at?(
                      art.date_at.split(' ')[0].split('-')[2]+'/'+
                      art.date_at.split(' ')[0].split('-')[1]+'/'+
                      art.date_at.split(' ')[0].split('-')[0]
                    ):'---'}
                  </td>
                  <td className="align-middle">
                    {art.files.map((file) => (
                      <File
                        key={file.id}
                        extension={file.extension}
                        comment={file.comment}
                        uri={file.uri}
                      />
                    ))}
                  </td>
                  <td className="text-center align-middle">
                    <Row style={{width:'80px'}} className="justify-content-around">
                      <Button
                        variant="success"
                        size="sm"
                        className="col-auto"
                        alt={t('title:approval art')}
                        title={t('title:approval art')}
                        onClick={() =>
                          approvedArt(
                            art.id,
                            art.action_id,
                            art.action_task_item_id,
                            art.action_task_item.task_id
                          )
                        }
                        disabled={art.status_id === 12 || art.status_id === 11 || art.status_id === 18}
                      >
                        <i className="fas fa-check"></i>
                      </Button>
                      <Button
                        variant="danger"
                        size="sm"
                        className="col-auto"
                        alt={t('title:disapproval art')}
                        title={t('title:disapproval art')}
                        onClick={() =>
                          disapprovedArt(
                            art.id,
                            art.action_id,
                            art.action_task_item_id
                          )
                        }
                        disabled={art.status_id === 12 || art.status_id === 11 || art.status_id === 18}
                      >
                        <i className="fas fa-times"></i>
                      </Button>
                    </Row>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  comprovationApproval: (payload) =>
    dispatch({ type: ASYNC_COMPROVATION_APPROVAL, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreativeApproval);
